module.exports = __webpack_public_path__ + "img/icon-b.4c05d212.png";